import { ApplePayError, PaymentMethodType } from '../../model'

interface PayMonthlyConfirmationBlockingState {
  applePayEnabledForConsumerLending: boolean
  applePayError?: ApplePayError
  bankAccountReason?: string | null
  bankAccountValid?: boolean
  cardReason?: string | null
  cardValid?: boolean
  cashPayMonthlyEnabled: boolean
  hasBankAccount: boolean
  hasCard: boolean
  preferredPaymentMethod?: PaymentMethodType | null
  selectedPaymentMethodType?: PaymentMethodType
}

export const isPayMonthlyConfirmationBlocked = ({
  applePayEnabledForConsumerLending,
  applePayError,
  bankAccountReason,
  bankAccountValid,
  cardReason,
  cardValid,
  cashPayMonthlyEnabled,
  hasBankAccount,
  hasCard,
  preferredPaymentMethod,
  selectedPaymentMethodType,
}: PayMonthlyConfirmationBlockingState): boolean => {
  if (selectedPaymentMethodType === undefined) {
    return true
  }

  const hasBlockingApplePayError = applePayError !== undefined && applePayError !== ApplePayError.InvalidCardType && applePayError !== ApplePayError.BinBlocked
  const hasInvalidBankAccount =
    preferredPaymentMethod === PaymentMethodType.ACH_BANK_ACCOUNT &&
    selectedPaymentMethodType === PaymentMethodType.ACH_BANK_ACCOUNT &&
    hasBankAccount &&
    bankAccountReason != null &&
    bankAccountValid !== true
  const hasDisabledApplePay =
    preferredPaymentMethod === PaymentMethodType.APPLE_PAY && selectedPaymentMethodType === PaymentMethodType.APPLE_PAY && !applePayEnabledForConsumerLending
  const hasDisabledCashAppPay =
    preferredPaymentMethod === PaymentMethodType.CASH_APP_PAY && selectedPaymentMethodType === PaymentMethodType.CASH_APP_PAY && !cashPayMonthlyEnabled
  const hasInvalidCard = selectedPaymentMethodType === PaymentMethodType.CREDIT_CARD && hasCard && cardReason != null && cardValid !== true

  return hasBlockingApplePayError || hasInvalidBankAccount || hasDisabledApplePay || hasDisabledCashAppPay || hasInvalidCard
}
